import { Component, OnInit } from '@angular/core';
import { LogicService } from './service/logic.service';
import { Values } from './enum/values.enum';
import { ColorValue } from './enum/color-value.enum'
import { RegexValue } from './enum/regex-value.enum';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './max640px.scss']
})
export class AppComponent implements OnInit {

  constructor(private logicService: LogicService) { }

  valueEnum = Values;
  colorValEnum = ColorValue;
  regexValueEnum = RegexValue;

  maxValue: number = 999999999;

  inputValue: string = '';
  valueRegex: string;// = '^[0-9]+$';
  valueRegexTab: string[] = ['^[0-1]+$', '^[0-9]+$', '^[a-f0-9]+$'];
  regFlag: boolean = true;

  decCheck: boolean = true;
  hexCheck: boolean;
  binCheck: boolean ;
  colorCheck: boolean ;
  checkOn: string = 'decPressCheck';

  tabValues = [];

  tabColor = [128, 128, 128, 0.5];
  rgbaColor: string;

  ngOnInit(): void {
    this.valueRegex = this.valueRegexTab[this.regexValueEnum.dec];
  }

  convert() {

    if (this.inputValue != '') this.logicService.convertValue(this.inputValue);
    else this.logicService.convertValue('0');



    for(var i=0; i < this.valueEnum.tabLenght; i++){
      this.logicService.getValues(i).subscribe(value => {
        this.tabValues[i] = value;
      });
    }
  }

  clear() {
    this.inputValue = '';
    for(var i = 0; i < this.valueEnum.tabLenght; i++){
      this.tabValues[i] = '';
    }
  }

  checkClick(event: string){

    this.hexCheck = false;
    this.decCheck = false;
    this.binCheck = false;
    this.colorCheck = false;
    this.valueRegex = '';
    this.checkOn = event;

    if (event === 'binPressCheck') {
      this.binCheck = true;
      this.valueRegex = this.valueRegexTab[this.regexValueEnum.bin];
      this.regFlag = true;
    }
    else if (event === 'decPressCheck') {
      this.decCheck = true;
      this.valueRegex = this.valueRegexTab[this.regexValueEnum.dec];
      this.regFlag = true;
    }
    else if (event === 'hexPressCheck') {
      this.hexCheck = true;
      this.valueRegex = this.valueRegexTab[this.regexValueEnum.hex];
      this.regFlag = true;
    }
    else if (event === 'colorPressCheck') this.colorCheck = true;
  }

  rgbaConvert(): string{
    this.rgbaColor = 'rgba(' + this.tabColor[this.colorValEnum.r] + ' , ' + this.tabColor[this.colorValEnum.g] +
    ' , ' + this.tabColor[this.colorValEnum.b] + ' , ' + this.tabColor[this.colorValEnum.alpha] + ')';
    return this.rgbaColor;
  }

  regValid(reg , data){
    let regexp = new RegExp(reg);
    this.regFlag = regexp.test(data);
  }
}

